import React, { useState, useEffect } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { StyledDataGrid } from "../../../../common/components/DataGrid/styles";
import { StyledButton } from "../../../../common/components/Button";
import AddTermsOfPaymentDialog from "./AddTermsOfPaymentDialog";
import { StyledH2 } from "../../../../common/components/Title/styles";
import UpdateTermsOfPaymentDialog from "./UpdateTermsOfPaymentDialog";
import { deleteTermsOfPayment } from "../../../../api/termsOfPaymentApi";
import { getAllTermsOfPaymentByType } from "../../../../api/termsOfPaymentApi";
import ConfirmationDialog from "../../../../common/components/Dialog";
import ShowScheduleDialog from "./ShowScheduleDialog";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
const TermsOfPayment = ({
  theme,
  handleOpenAlert,
  handleSetAlertMessage,
  isTabBeforeDesign,
}) => {
  const [openAddTermsOfPayment, setOpenAddTermsOfPayment] = useState(false);
  const [openViewSchedule, setOpenViewSchedule] = useState(false);
  const [openUpdateTermsOfPayment, setOpenUpdatelignerMaterial] =
    useState(false);
  const [rows, setRows] = useState([]);
  const [currentTermsOfPayment, setCurrentTermsOfPayment] = useState({});
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [confirmationSubmit, setConfirmationSubmit] = useState(
    () => () => null
  );
  useEffect(() => {
    fetchTermsOfPayments();
  }, []);

  const fetchTermsOfPayments = async () => {
    const response = await getAllTermsOfPaymentByType(
      isTabBeforeDesign ? 0 : 1
    );
    setRows([...response]);
  };

  const handleOpenAddTermsOfPayment = () => {
    setOpenAddTermsOfPayment(true);
  };

  const handleCloseAddTermsOfPayment = () => {
    console.log("currentTermsOfPayment", currentTermsOfPayment);
    setOpenAddTermsOfPayment(false);
  };

  const handleOpenViewSchedule = (schedule) => {
    setCurrentTermsOfPayment(schedule);
    setOpenViewSchedule(true);
  };
  const handleCloseViewSchedule = () => {
    setOpenViewSchedule(false);
  };

  //Update
  const handleOpenUpdateTermsOfPayment = (event, params) => {
    event.stopPropagation();
    setCurrentTermsOfPayment({ ...params.row });
    setOpenUpdatelignerMaterial(true);
  };
  const handleCloseUpdateTermsOfPayment = () => {
    setOpenUpdatelignerMaterial(false);
  };

  const handleDeleteTermsOfPayment = async (id) => {
    await deleteTermsOfPayment({ Id: id });
    // if (response.data.error != null) {
    //   setErrorMessage(response.data.error.message);
    //   handleOpenSnackbar();
    // }
    await fetchTermsOfPayments();
  };

  const columns = [
    { field: "name", headerName: "Terms of Payment", flex: 1 },
    {
      field: "col5",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        return [
          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faCalendar} />}
            label="View"
            onClick={() => {
              handleOpenViewSchedule(params.row);
            }}
          />,

          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faTrash} />}
            label="Delete"
            onClick={(e) => {
              e.stopPropagation();
              setShowConfirmationDialog(true);
              setConfirmationSubmit(() => () => {
                handleDeleteTermsOfPayment(params.id);
                setShowConfirmationDialog(false);
              });
            }}
          />,
        ];
      },
    },
  ];

  return (
    <div>
      <StyledH2 theme="purple">
        {isTabBeforeDesign
          ? "Terms of Payment Before Design"
          : "Terms of Payment After Design"}
      </StyledH2>
      <StyledButton onClick={handleOpenAddTermsOfPayment} theme="green">
        <FontAwesomeIcon icon={faPlus} style={{ paddingRight: "3px" }} />
        Add terms of payment
      </StyledButton>
      <ShowScheduleDialog
        schedule={currentTermsOfPayment.paymentSchedules}
        modeOfPayment={currentTermsOfPayment.modeOfPayment}
        open={openViewSchedule}
        onClose={handleCloseViewSchedule}
        isTabBeforeDesign={isTabBeforeDesign}
      />
      <AddTermsOfPaymentDialog
        openAddTermsOfPayment={openAddTermsOfPayment}
        handleCloseAddTermsOfPayment={handleCloseAddTermsOfPayment}
        currentTermsOfPayment={currentTermsOfPayment}
        fetchTermsOfPayments={fetchTermsOfPayments}
        handleOpenAlert={handleOpenAlert}
        handleSetAlertMessage={handleSetAlertMessage}
        isTabBeforeDesign={isTabBeforeDesign}
      />
      <UpdateTermsOfPaymentDialog
        openUpdateTermsOfPayment={openUpdateTermsOfPayment}
        handleCloseUpdateTermsOfPayment={handleCloseUpdateTermsOfPayment}
        currentTermsOfPayment={currentTermsOfPayment}
        fetchTermsOfPayments={fetchTermsOfPayments}
      />
      <ConfirmationDialog
        open={showConfirmationDialog}
        handleClose={() => setShowConfirmationDialog(false)}
        submit={confirmationSubmit}
        title={"Delete selected terms of payment?"}
      />
      <StyledDataGrid
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[]}
      />
    </div>
  );
};

export default TermsOfPayment;
